/**
 * @generated SignedSource<<1c78429a6761d2f797f4f34bef91bbf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateTravelDocumentInput = {
  name: string;
};
export type TravelDocumentsListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateTravelDocumentInput;
};
export type TravelDocumentsListAddMutation$data = {
  readonly createTravelDocument: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"TravelDocumentsListRow_document">;
    } | null;
  };
};
export type TravelDocumentsListAddMutation = {
  response: TravelDocumentsListAddMutation$data;
  variables: TravelDocumentsListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelDocumentsListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TravelDocumentNode",
        "kind": "LinkedField",
        "name": "createTravelDocument",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TravelDocument",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TravelDocumentsListRow_document"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TravelDocumentsListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TravelDocumentNode",
        "kind": "LinkedField",
        "name": "createTravelDocument",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TravelDocument",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "TravelDocumentEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44c3a27ea7a8121f22b72b45627335df",
    "id": null,
    "metadata": {},
    "name": "TravelDocumentsListAddMutation",
    "operationKind": "mutation",
    "text": "mutation TravelDocumentsListAddMutation(\n  $input: CreateTravelDocumentInput!\n) {\n  createTravelDocument(input: $input) {\n    node {\n      ...TravelDocumentsListRow_document\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment TravelDocumentsListRow_document on TravelDocument {\n  id\n  name\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "b1a89df8a5a32cb1629728976562c503";

export default node;
